import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    '&&': {
      minHeight: 300,

      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.xl,

      padding: SPACES.xxxxl,

      [theme.breakpoints.down('tablet')]: {
        maxWidth: 'calc(100vw - 32px)',
        minWidth: 300,
      },
      [theme.breakpoints.up('tablet')]: {
        width: 400,
      },
    },
  },
  title: {
    textAlign: 'center',
    margin: 0,
  },
  form: {
    flex: 1,

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: SPACES.xxxl,
  },
  inputsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.m,
  },
  accountWarning: {
    display: 'flex',
    gap: SPACES.s,
    justifyContent: 'center',
    alignItems: 'center',

    fontSize: FONTS.SIZES.m,
    color: theme.palette.custom.darkBlue2,
    fontWeight: FONTS.WEIGHTS.normal,
  },
  infoWrapper: {
    '&&': {
      display: 'inline-flex',
    },
  },
  infoList: {
    margin: 0,
    paddingLeft: 0,
    listStyle: 'none',
  },
  infoIcon: {
    '&&': {
      width: 20,
      height: 20,
    },
  },
}))
